import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { ESubscriptionCancellationReason } from "@devowl-wp/api-real-commerce";
import { StatusPill } from "./statusPill.js";
import { formatLocaleDate } from "../../../../../utils/formatLocaleDate.js";
import { __, _i } from "../../../../../utils/i18n.js";
const SubscriptionStatusPill = observer(({ subscription })=>{
    const { cancellationReason } = subscription.data;
    if (subscription.isPastDue) {
        return /*#__PURE__*/ _jsx(StatusPill, {
            kind: "warning",
            label: __("Past due"),
            tooltip: _i(__("{{strong}}The renewal payment hasn't gone through yet.{{/strong}} Update your payment method via the actions menu to restore the subscription."), {
                strong: /*#__PURE__*/ _jsx("strong", {})
            })
        });
    }
    if (cancellationReason === ESubscriptionCancellationReason.PaymentFailed && (subscription.isCancelled || subscription.isCancellationPending)) {
        return /*#__PURE__*/ _jsx(StatusPill, {
            kind: "error",
            label: __("Payment failed"),
            tooltip: __("Your subscription was cancelled because we were unable to debit the agreed fee.")
        });
    }
    if (subscription.isCancelled) {
        return /*#__PURE__*/ _jsx(StatusPill, {
            kind: "neutral",
            label: __("Cancelled")
        });
    }
    if (subscription.isCancellationPending) {
        // Pill states *when* access ends, not the cancellation state — "pending"
        // or "confirmed" both suggest admin process outstanding, whereas the
        // customer's actual concern is "until when do I still have access?".
        const endDate = formatLocaleDate(subscription.data.validUntil);
        return /*#__PURE__*/ _jsx(StatusPill, {
            kind: "warning",
            label: __("Not renewing"),
            tooltip: __("Your cancellation is on file. Access ends on %s. After that, the subscription ends automatically.", endDate)
        });
    }
    // Lifetime / one-time purchases use the same "Active" wording as
    // recurring subscriptions — the pill signals "is this contract live?",
    // not the billing cadence (which the primary-date label conveys).
    return /*#__PURE__*/ _jsx(StatusPill, {
        kind: "active",
        label: __("Active")
    });
});
export { SubscriptionStatusPill };
